import React from 'react'
import { StyledIconPropsType } from './types'

const InfoWMO = ({
  icon = "info",
  viewBox= "0 0 14 14",
  width = "14",
  height = "14",
  customProps = {}
} : StyledIconPropsType) => {
  return (
    <svg aria-label={icon} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" {...customProps}>
    <g clipPath="url(#clip0_1048_26147)">
      <path d="M7.00033 12.8332C10.222 12.8332 12.8337 10.2215 12.8337 6.99984C12.8337 3.77818 10.222 1.1665 7.00033 1.1665C3.77866 1.1665 1.16699 3.77818 1.16699 6.99984C1.16699 10.2215 3.77866 12.8332 7.00033 12.8332Z" stroke="#5C5C5C" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 4.6665V6.99984" stroke="#5C5C5C" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 9.3335H7.00667" stroke="#5C5C5C" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1048_26147">
        <rect width="14" height="14" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  )
}

export default InfoWMO
